module.exports = __webpack_public_path__ + "img/airtke_set.62298b3c.jpg";